import React, { useEffect, useState } from 'react';
import ResourceTabs from '../common/ResourceTabs';
import Filter from '../common/tables/Filter';
import { Button, Icon, Toolbar, ToolbarItem } from '../common';
import { Searchbar } from '../common/components/Searchbar';
import CheckboxFilter from '../common/tables/CheckboxFilter';
import { PortOpeningRequestsDirection } from '../../models/enums/POR/PortOpeningRequestsDirection';
import { AWSPortOpeningRequestsTypes } from '../../models/enums/POR/AWSPortOpeningRequestType';
import { OnPremPortOpeningRequestsTypes } from '../../models/enums/POR/OnPremPortOpeningRequestsTypes';
import { DoNotDecryptRequestsDirection } from '../../models/enums/DNDR/DoNotDecryptRequestsDirection';
import moment from 'moment';

interface Dictionary {
	[Key: string]: any;
}

interface ApprovalsHomeFiltersProps {
	setActiveTab: Function;
	activeTab: string;
	retrieveApprovals: any;
	listsDictionary: Dictionary;
	setFilteredAccounts: Function;
	setFilteredEnterpriseApps: Function;
	setFilteredPORs: Function;
	setFilteredDPIs: Function;
	setFilteredTAPs: Function;
	setFilteredOnPremObjects: Function;
	setFilteredS2SPORs: Function;
	setFilteredAWSPORs: Function;
	setFilteredOnPremPORs: Function;
	setFilteredAWSAccounts: Function;
	namesDictionary: Dictionary;
}

const ApprovalsHomeFilters = ({
	setActiveTab,
	activeTab,
	listsDictionary,
	setFilteredAccounts,
	setFilteredEnterpriseApps,
	setFilteredPORs,
	setFilteredDPIs,
	setFilteredTAPs,
	setFilteredOnPremObjects,
	setFilteredS2SPORs,
	setFilteredAWSPORs,
	setFilteredOnPremPORs,
	setFilteredAWSAccounts,
	namesDictionary,
	retrieveApprovals,
}: ApprovalsHomeFiltersProps) => {
	const resourceTabs = [];
	resourceTabs.push({
		item1: namesDictionary.accounts,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.apps,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.pors,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.dpis,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.taps,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.onpremobjects,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.s2spors,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.awspors,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.onprempors,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.awsaccounts,
		item2: null,
	});
	const defaultFilters = {
		searchGeneral: '',
		showResources: namesDictionary[activeTab],
		porType: [
			{ label: 'Subscription <-> ExxonMobil Network', value: PortOpeningRequestsDirection.SubscriptionToOnPrem.name, checked: true },
			{ label: 'Subscription -> Internet', value: PortOpeningRequestsDirection.SubscriptionToInternet.name, checked: true },
		],
		awsPorType: [
			{ label: AWSPortOpeningRequestsTypes.AccountToInternet.displayName, value: AWSPortOpeningRequestsTypes.AccountToInternet.name, checked: true },
			{ label: AWSPortOpeningRequestsTypes.AccountToDMZ.displayName, value: AWSPortOpeningRequestsTypes.AccountToDMZ.name, checked: true },
			{ label: AWSPortOpeningRequestsTypes.Untrusted.displayName, value: AWSPortOpeningRequestsTypes.Untrusted.name, checked: true },
		],
		onPremPorType: [
			{ label: OnPremPortOpeningRequestsTypes.InternetDMZ.displayName, value: OnPremPortOpeningRequestsTypes.InternetDMZ.name, checked: true },
			{ label: OnPremPortOpeningRequestsTypes.InternalCertConnection.displayName, value: OnPremPortOpeningRequestsTypes.InternalCertConnection.name, checked: true },
		],
		dpiType: [
			{ label: DoNotDecryptRequestsDirection.SubscriptionToInternet.displayName, value: DoNotDecryptRequestsDirection.SubscriptionToInternet.name, checked: true },
			{ label: DoNotDecryptRequestsDirection.SubscriptionToOnPrem.displayName, value: DoNotDecryptRequestsDirection.SubscriptionToOnPrem.name, checked: true },
			{ label: DoNotDecryptRequestsDirection.OnPremToInternet.displayName, value: DoNotDecryptRequestsDirection.OnPremToInternet.name, checked: true },
			{ label: DoNotDecryptRequestsDirection.NECTUpdate.displayName, value: DoNotDecryptRequestsDirection.NECTUpdate.name, checked: true },
		],
		onPremObjectType: [
			{ label: OnPremPortOpeningRequestsTypes.InternetDMZ.displayName, value: OnPremPortOpeningRequestsTypes.InternetDMZ.name, checked: true },
			{ label: OnPremPortOpeningRequestsTypes.InternalCertConnection.displayName, value: OnPremPortOpeningRequestsTypes.InternalCertConnection.name, checked: true },
		],
	};

	const filterApprovals = () => {
		const filterCallback = (element: any) => {
			return (
				filter.filterSearchText('searchGeneral', element.createdUserPrincipalName) ||
				filter.filterSearchText('searchGeneral', element.displayName) ||
				filter.filterSearchText('searchGeneral', element.subscriptionRequestName) ||
				filter.filterSearchText('searchGeneral', element.requestor?.displayName) ||
				filter.filterSearchText('searchGeneral', element.owner?.displayName) ||
				filter.filterSearchText('searchGeneral', element.newOwner?.displayName)
			);
		};
		let filtered = [];
		switch (filter.filters.showResources) {
			case 'Cloud Accounts':
				setActiveTab('accounts');
				filtered = listsDictionary.accounts.filter(filterCallback);
				filtered.sort((a, b) => {
					return (
						moment(b.workflowInstance.createdDate).valueOf() -
						moment(a.workflowInstance.createdDate).valueOf()
					);
				});
				setFilteredAccounts(filtered);
				break;
			case 'Entra Id Apps':
				setActiveTab('apps');
				filtered = listsDictionary.apps.filter(filterCallback);
				setFilteredEnterpriseApps(filtered);
				break;
			case 'PORs':
				setActiveTab('pors');
				filtered = listsDictionary.pors
					.filter(filterCallback)
					.filter((element: any) => filter.filterCheckBox('porType', element.direction?.name));
				setFilteredPORs(filtered);
				break;
			case 'DPIs':
				setActiveTab('dpis');
				filtered = listsDictionary.dpis
					.filter(filterCallback)
					.filter((element: any) => filter.filterCheckBox('dpiType', element.direction?.name));
				setFilteredDPIs(filtered);
				break;
			case 'TAPs':
				setActiveTab('taps');
				filtered = listsDictionary.taps.filter(filterCallback);
				setFilteredTAPs(filtered);
				break;
			case 'On-Prem Objects':
				setActiveTab('onpremobjects');
				filtered = listsDictionary.onpremobjects
					.filter(filterCallback)
					.filter((element: any) => filter.filterCheckBox('onPremObjectType', element.type?.name));
				setFilteredOnPremObjects(filtered);
				break;
			case 'S2S PORs':
				setActiveTab('s2spors');
				filtered = listsDictionary.s2spors.filter(filterCallback);
				setFilteredS2SPORs(filtered);
				break;
			case 'AWS PORs':
				setActiveTab('awspors');
				filtered = listsDictionary.awspors
					.filter(filterCallback)
					.filter((element: any) => filter.filterCheckBox('awsPorType', element.type?.name));
				setFilteredAWSPORs(filtered);
				break;
			case 'On-Prem PORs':
				setActiveTab('onprempors');
				filtered = listsDictionary.onprempors
					.filter(filterCallback)
					.filter((element: any) => filter.filterCheckBox('onPremPorType', element.type?.name));
				setFilteredOnPremPORs(filtered);
				break;
			case 'AWS Accounts':
				setActiveTab('awsaccounts');
				filtered = listsDictionary.awsaccounts.filter(filterCallback);
				setFilteredAWSAccounts(filtered);
				break;
		}
	};
	useEffect(() => {
		filter.filter();
	}, []);

	useEffect(() => {
		filter.updateFilterFunction(filterApprovals);
	}, [listsDictionary]);
	const clearSearchbar = (e) => {
		e.preventDefault();
		filter.updateFilter('', 'searchGeneral');
	};

	const handleRefresh = () => {
		filter.updateFilter('My Approvals', 'Show Resources');
		retrieveApprovals(true);
	};

	const [filter, setFilter] = useState<Filter<any>>(new Filter(filterApprovals, defaultFilters));
	return (
		<>
			<ResourceTabs allResources={resourceTabs} filter={filter} />
			<Toolbar id="toggle-toolbar">
				<ToolbarItem width='lg'>
					<Searchbar
						condensed
						onClick={clearSearchbar}
						value={filter.filters.searchGeneral}
						onChange={(e) => filter.handleSearchTextChange(e, 'searchGeneral')}
						placeholder={'Search'}
					/>
				</ToolbarItem>
				{activeTab === 'dpis' && (
					<ToolbarItem>
						<CheckboxFilter
							label="Type"
							onChange={(event) => filter.handleCheckboxChange(event, 'dpiType')}
							options={filter.filters.dpiType}
							allDefaultChecked={true}
						/>
					</ToolbarItem>
				)}
				{activeTab === 'onpremobjects' && (
					<ToolbarItem>
						<CheckboxFilter
							label="Type"
							onChange={(event) => filter.handleCheckboxChange(event, 'onPremObjectType')}
							options={filter.filters.onPremObjectType}
							allDefaultChecked={true}
						/>
					</ToolbarItem>
				)}
				{activeTab === 'pors' && (
					<ToolbarItem>
						<CheckboxFilter
							label="Type"
							onChange={(event) => filter.handleCheckboxChange(event, 'porType')}
							options={filter.filters.porType}
							allDefaultChecked={true}
						/>
					</ToolbarItem>
				)}
				{activeTab === 'awspors' && (
					<ToolbarItem>
						<CheckboxFilter
							label="Type"
							onChange={(event) => filter.handleCheckboxChange(event, 'awsPorType')}
							options={filter.filters.awsPorType}
							allDefaultChecked={true}
						/>
					</ToolbarItem>
				)}
				{activeTab === 'onprempors' && (
					<ToolbarItem>
						<CheckboxFilter
							label="Type"
							onChange={(event) => filter.handleCheckboxChange(event, 'onPremPorType')}
							options={filter.filters.onPremPorType}
							allDefaultChecked={true}
						/>
					</ToolbarItem>
				)}
				<ToolbarItem>
					<Button size='small' variant="secondary" onClick={handleRefresh}>
						<Icon icon="refresh" size="small" />
						<span> Refresh</span>
					</Button>
				</ToolbarItem>
			</Toolbar>
		</>
	);
};

export default ApprovalsHomeFilters;
